import { useEffect } from 'react'
import { BackHandler } from 'react-native'
import { userGroupsQuery } from '../../queries'
import { fetchSuggestedGroupsQuery } from '../../screens/groups-screen/queries'
import { useLeaveGroup } from './commands'
import { ConfirmationModal, ConfirmationModalOption, useToastController } from '@my/ui'

export interface LeaveGroupModalContainerProps {
  groupId: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const LeaveGroupModalContainer = (props: LeaveGroupModalContainerProps) => {
  const toast = useToastController()
  const [leaveGroup, { loading }] = useLeaveGroup()

  useEffect(() => {
    const backAction = () => {
      props.onOpenChange(false);
      return props.open
    }

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => backHandler.remove();
  }, [])

  const handleSubmit = async () => {
    try {
      await leaveGroup({
        variables: {
          groupId: props.groupId,
        },
        onCompleted: (data) => {
          if (data.leaveGroup.success) {
            toast.show(`You've left the group`)
          }
        },
        onError: (error) => {
          toast.show("Couldn't leave the group", { burntOptions: { preset: 'error' } })
          console.log(error)
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: userGroupsQuery.query,
            variables: {
              ...userGroupsQuery.defaultVariables,
            },
          },
          {
            query: fetchSuggestedGroupsQuery,
            variables: {
              limit: 10,
            },
          },
        ],
      })
      props.onOpenChange(false)
    } catch (error) {
      console.error(error)
    }
  }

  const options: ConfirmationModalOption[] = [
    {
      children: 'Yes, Leave group',
      theme: 'black',
      onPress: handleSubmit,
      loading,
    },
    {
      children: 'No, Discard',
      plain: true,
      onPress: () => props.onOpenChange(false),
    },
  ]

  return (
    <ConfirmationModal
      title="Are you sure you want to leave this group?"
      open={props.open}
      onOpenChange={props.onOpenChange}
      onSubmit={handleSubmit}
      options={options}
    />
  )
}
